import { render, staticRenderFns } from "./hierarchyPicBox.vue?vue&type=template&id=618b4aa0&scoped=true"
import script from "./hierarchyPicBox.vue?vue&type=script&lang=js"
export * from "./hierarchyPicBox.vue?vue&type=script&lang=js"
import style0 from "./hierarchyPicBox.vue?vue&type=style&index=0&id=618b4aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618b4aa0",
  null
  
)

export default component.exports